import * as React from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import GatewayModalDelete from "./GatewaySensorModalDelete";
import Modal from '@mui/material/Modal';
import axios from "axios";
import { useState, useEffect } from "react";
import { useCookies } from 'react-cookie';
import baseUrlApi from '../../lib/baseUrlApi';
import { type } from 'os';
import Utility from 'Consts/Utility';
import Select, {SingleValue} from 'react-select';
import {ApiRequest} from "../../Consts/ApiRequest";
import { modalProps } from '../../Consts/constants';
import { useParams, useNavigate } from "react-router-dom";

type GatewayActionInputs = {
  gatewayRecno: number;
  controlID: string;
  noise: {
    sensorId: string;
    sensorRecno: number;
  };
  env: {
    sensorId: string;
    sensorRecno: number;
  };
  sui: {
    sensorId: string;
    sensorRecno: number;
  },
  contactEnd: string;
};
type SensorData = {
  "sensorRecno": number;
  "sensorID": string,
  "sensorName": string,
  "sensorKind": number,
  "assigned": boolean
};
interface GatewayProps {
  // controlId?: string;
  prcKind: number;
  noise?: {
    sensorId: string,
    sensorRecno: number,
  };
  env?: {
    sensorId: string,
    sensorRecno: number,
  };
  sui?: {
    sensorId: string,
    sensorRecno: number,
  };
  contactEnd: string;
  sensors: SensorData[],
  gatewayRecno: number;
  siteId: string;
  siteRecno: string;
  gateways: any[]
  controlID: string;
  controlIDs: any[];
  gatewayRecnos: any[];
  noiseSensorRecno: number;
  envSensorRecno: number;
  suiSensorRecno: number;
  getGatewayData: any[]
  getGatewaySensor: Function;
};
export default function BasicModal(props: GatewayProps) {
  // const GatewayControl = props.controlId;
  const gatewayRecno = props.gatewayRecno;
  const noise = props.noise;
  const env = props.env;
  const sui = props.sui;

  const siteRecno = props.siteRecno;
  const sensors = props.sensors;
  const prcKind = props.prcKind;
  const gateways = props.gateways;
  const selectedControlID = props.controlID;
  const controlIDs = props.controlIDs;
  const getGatewayData = props.getGatewayData;
  const [open, setOpen] = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm<GatewayActionInputs>();
  const [gatewayPostData, setGatewayPostData] = useState<GatewayActionInputs[]>([]);
  const [contactEnd, setcontactEnd] = useState<string>(prcKind === 1 ? props.contactEnd : (""))
  const navigate = useNavigate();

  const resetData = async() => {
    _a(props.noiseSensorRecno);
    _b(props.envSensorRecno);
    _c(props.suiSensorRecno);

    setcontactEnd("");
    setNoiseSensorRecno(props.noiseSensorRecno);
    setEnvSensorRecno(props.envSensorRecno);
    setSuiSensorRecno(props.suiSensorRecno);
    setcontactEnd(prcKind === 1 ? props.contactEnd : (""));
    setcontactEnd(Utility.formatDateStr(props.contactEnd));
    setControlID(props.controlID);
    setNewGatewayRecno(0);
    setNoiseSensorId("");
    setEnvSensorId("");
    setSuiSensorId("");
    setError([]);
  }
  const handleClose = async() => {
    await resetData();
    setOpen(false)
  };
  const handleOpen = async() => {
    await resetData();
    setOpen(true)
  }

  function handleDateChange(e: React.ChangeEvent<HTMLInputElement>) {
    const inputDateString = e.target.value;
    const formattedDate = Utility.formatDateStr(inputDateString);
    if (formattedDate) {
      setcontactEnd(formattedDate);
    }
  }

  const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', "siteId", "siteRecno"]);
  const [controlID, setControlID] = useState<string>(prcKind === 1 ? (gateways ? gateways[0].controlID : "") : "");
  const [newGatewayRecno, setNewGatewayRecno] = useState<number>(prcKind === 1 ? (gateways ? gateways[0].gatewayRecno : 0) : 0);
  const [noiseSensorId, setNoiseSensorId] = useState<string>(prcKind === 1 ? (noise ? noise.sensorId : "") : "");
  const [envSensorId, setEnvSensorId] = useState<string>(prcKind === 1 ? (env ? env?.sensorId : "") : "");
  const [suiSensorId, setSuiSensorId] = useState<string>(prcKind === 1 ? (sui ? sui?.sensorId : "") : "");

  const [oldNoiseSensorRecno, _a] = useState<number>(props.noiseSensorRecno);
  const [oldEnvSensorRecno, _b] = useState<number>(props.envSensorRecno);
  const [oldSuiSensorRecno, _c] = useState<number>(props.suiSensorRecno);
  const [noiseSensorRecno, setNoiseSensorRecno] = useState<number>(props.noiseSensorRecno);
  const [envSensorRecno, setEnvSensorRecno] = useState<number>(props.envSensorRecno);
  const [suiSensorRecno, setSuiSensorRecno] = useState<number>(props.suiSensorRecno);
  const [error, setError] = useState<[]>([]);

    function errorCallback(error:any){
        if (error.response && error.response.status === 401) {
            console.error("Error token error:", error);
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
        console.error("Error fetching dataSite:", error);
    }

  const handleControlSelectChange = (newValue: any) => {
    let value = newValue.value;
    setControlID(value);
    getGatewayData.forEach(element => {
      if (element.controlID === value) {
        setNewGatewayRecno(element.gatewayRecno);
      }
    });
  };

  const handleNoiseSelectChange = (newValue: any) => {
    let value = newValue.value;
    let result = false
    setNoiseSensorId(value);
    sensors.forEach(element => {
      if (element.sensorID === value) {
        result = true;
        setNoiseSensorRecno(element.sensorRecno);
      }
    });
    if(!result){
      setNoiseSensorRecno(0);
    }
  };

  const handleEnvSelectChange = (newValue: any) => {
    let value = newValue.value;
    let result = false
    setEnvSensorId(value);
    sensors.forEach(element => {
      if (element.sensorID === value) {
        result = true;
        setEnvSensorRecno(element.sensorRecno);
      }
    });

    if(!result){
      setEnvSensorRecno(0);
    }
  };

  const handleSuiSelectChange = (newValue: any) => {
    let value = newValue.value;
    let result = false
    setSuiSensorId(value);
    sensors.forEach(element => {
      if (element.sensorID === value) {
        result = true;
        setSuiSensorRecno(element.sensorRecno);
      }
    });
    if(!result){
      setSuiSensorRecno(0);
    }
  };

  const onSubmit: SubmitHandler<GatewayActionInputs> = async (data) => {
    const ReformattedDate = Utility.ReformatDate(contactEnd);

    let dataPayload;
    if (prcKind === 1) {
      dataPayload = {
        "prcKind": prcKind,
        "siteRecno": siteRecno,
        "gatewayRecno": gatewayRecno,
        "gatewayRecnoOld": gatewayRecno,
        "controlID": selectedControlID,
        noise: {
          "sensorID": noiseSensorId ?? "",
          "sensorRecno": noiseSensorRecno,
          "sensorRecnoOld": oldNoiseSensorRecno,
        },
        env: {
          "sensorID": envSensorId ?? "",
          "sensorRecno": envSensorRecno,
          "sensorRecnoOld": oldEnvSensorRecno,
        },
        sui: {
          "sensorID": suiSensorId ?? "",
          "sensorRecno": suiSensorRecno,
          "sensorRecnoOld": oldSuiSensorRecno,
        },
        "contactEnd": ReformattedDate
      };
    } else if (prcKind === 0) {
      dataPayload =
      {
        "prcKind": prcKind,
        "siteRecno": siteRecno,
        "gatewayRecno": newGatewayRecno,
        "gatewayRecnoOld": gatewayRecno,
        "controlID": controlID,
        noise: {
          "sensorID": noiseSensorId ?? "",
          "sensorRecno": noiseSensorRecno,
          "sensorRecnoOld": oldNoiseSensorRecno,
        },
        env: {
          "sensorID": envSensorId ?? "",
          "sensorRecno": envSensorRecno,
          "sensorRecnoOld": oldEnvSensorRecno,
        },
        sui: {
          "sensorID": suiSensorId ?? "",
          "sensorRecno": suiSensorRecno,
          "sensorRecnoOld": oldSuiSensorRecno,
        },
        "contactEnd": ReformattedDate
      };
    }

    try {
        const token = cookies.access_token || "";
        await ApiRequest.registGatewaySensor(dataPayload,  token, (response:any) => {
            // console.log(response);
            if (Array.isArray(response.data)) {
                setGatewayPostData(response.data);
            }
            setError(response.data.messsages);
            if (response.data.result === 0) {
                handleClose();
            }
            props.getGatewaySensor(" ");
        }, (error:any) => {
            errorCallback(error);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const options = [
    { value: "none", label: "Empty" },
    { value: "left", label: "Open Left" },
    { value: "right", label: "Open Right" },
    {
      value: "tilt,left",
      label: "Tilf and Open Left"
    },
    {
      value: "tilt,right",
      label: "Tilf and Open Right"
    }
  ];
  return (
    <div>
      <button onClick={handleOpen} className={`btn ${prcKind === 1 ? 'btn-blue-line' : 'btn-blue'}`}>
        <i className={`icon ${prcKind === 1 ? 'icon-edit-b' : 'icon-add-w'}`}></i>
        {prcKind === 1 ? '編集' : 'Gateway追加'}
      </button>
      <Modal {...modalProps} open={open} onClose={handleClose}>
        <div className="modal-wrapper"
          id="modal-message">
          <div className="modal">
            <div className="modal-header">
              <div className="modal-title">
                {prcKind === 1 ? 'Gateway、センサ編集' : 'Gateway、センサ新規追加'}
              </div>
              <a onClick={handleClose} className="modal-close"></a>
            </div>
            <div className="modal-body">
              <div className="edit-box">
                {
                  error && error.length > 0 ?
                    <ul className="error-box">
                      {error.map((err, index) => <li key={index}>{err}</li>)}
                    </ul>
                    : null
                }
                <div className="edit-box-elm">
                  <div className="edit-box-elm-name">
                    Gateway管理番号
                  </div>
                  <div className="edit-box-elm-input">
                    {prcKind === 1 ?
                      <input
                        type="text"
                        value={selectedControlID}
                        className="col-320"
                        onChange={e => setControlID(e.target.value)}
                      >
                      </input>
                      :
                      <Select
                          isSearchable={true}
                          className="col-320"
                          defaultValue={{value: null, label: null}}
                          options={controlIDs.map((option, index) => {
                              return { value: option, label: option };
                            })}
                         onChange={handleControlSelectChange}
                      />
                    }
                  </div>
                </div>
                <div className="edit-box-elm">
                  <div className="edit-box-elm-name">騒音振動</div>
                  <div className="edit-box-elm-input">
                    <Select
                        isSearchable={true}
                        className="col-320"
                        defaultValue={{value: props.noise?.sensorId, label: props.noise?.sensorId}}
                        options={
                          [{ value: "", label: "　" }].concat(
                              sensors
                                  .filter(sensor => sensor.sensorKind === 3 && !sensor.assigned)
                                  .map((option, index) => {
                                    return { value: option.sensorID, label: option.sensorID }
                                  }))
                        }
                        onChange={handleNoiseSelectChange}
                    />
                  </div>
                </div>
                <div className="edit-box-elm">
                  <div className="edit-box-elm-name">気象</div>
                  <div className="edit-box-elm-input">
                    <Select
                        isSearchable={true}
                        className="col-320"
                        defaultValue={{value: props.env?.sensorId, label: props.env?.sensorId}}
                        options={
                          [{ value: "", label: "　" }].concat(
                              sensors
                                  .filter(sensor => sensor.sensorKind === 2 && !sensor.assigned)
                                  .map((option, index) => {
                                    return { value: option.sensorID, label: option.sensorID }
                                  })
                          )
                        }
                        onChange={handleEnvSelectChange}
                    />
                  </div>
                </div>
                <div className="edit-box-elm">
                  <div className="edit-box-elm-name">水位</div>
                  <div className="edit-box-elm-input">
                    <Select
                        isSearchable={true}
                        className="col-320"
                        defaultValue={{value: props.sui?.sensorId, label: props.sui?.sensorId}}
                        options={
                          [{ value: "", label: "　" }].concat(
                              sensors
                                  .filter(sensor => sensor.sensorKind === 1 && !sensor.assigned)
                                  .map((option, index) => {
                                    return { value: option.sensorID, label: option.sensorID }
                                  }))
                        }
                        onChange={handleSuiSelectChange}
                    />
                  </div>
                </div>

                <div className="edit-box-elm">
                  <div className="edit-box-elm-name">契約終了日</div>
                  <div className="edit-box-elm-input">
                    <input
                      type="date"
                      value={Utility.formatDate(new Date(contactEnd))}
                      min="0000-01-01"
                      max="9999-12-31"
                      id=""
                      name="contactEnd"
                      className="col-320"
                      onChange={(e) => setcontactEnd(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="model-action-sub">
                {prcKind === 1 ? (
                  <GatewayModalDelete
                    gatewayRecno={gatewayRecno}
                    contactEnd={contactEnd}
                    controlId={selectedControlID}
                    suiSensorId={sui?.sensorId}
                    suiSensorRecno={sui?.sensorRecno}
                    envSensorId={env?.sensorId}
                    envSensorRecno={env?.sensorRecno}
                    noiseSensorId={noise?.sensorId}
                    noiseSensorRecno={noise?.sensorRecno}
                    closeModal={handleClose}
                    setState={props.getGatewaySensor}
                    siteId={props.siteId}
                    siteRecno={props.siteRecno}
                  />
                ) : null}
              </div>
              <div className="model-action-main">
                <button onClick={handleClose} className="btn btn-blue-line">
                  キャンセル
                </button>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <button className="btn btn-blue col-160">
                    <i className="icon-check-w"></i>確定
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
